import request from './api';
import {
  API_PUBLIC_ADDRESS,
  API_PUBLIC_BANK,
  API_IRPF_DATA
} from '../constants/api';

// Address services
export const getAddress = () =>
  request(API_PUBLIC_ADDRESS, {
    method: 'GET'
  });

export const createAddressChangeRequest = userAddress =>
  request(`${API_PUBLIC_ADDRESS}/changeAddress`, {
    method: 'POST',
    data: userAddress
  });

export const getAddressFromChangeRequest = () =>
  request(`${API_PUBLIC_ADDRESS}/changeAddress`, {
    method: 'GET'
  });

export const updateAddressChangeRequest = userAddress =>
  request(`${API_PUBLIC_ADDRESS}/changeAddress`, {
    method: 'PUT',
    data: userAddress
  });

export const deleteAddressChangeRequest = () =>
  request(`${API_PUBLIC_ADDRESS}/changeAddress`, {
    method: 'DELETE'
  });

// Bank services
export const getBankDetails = () =>
  request(API_PUBLIC_BANK, {
    method: 'GET'
  });

export const createIbanChangeRequest = ibanCode =>
  request(`${API_PUBLIC_BANK}/changeIBAN`, {
    method: 'POST',
    params: {
      ibanCode
    }
  });

export const getIbanFromChangeRequest = () =>
  request(`${API_PUBLIC_BANK}/changeIBAN`, {
    method: 'GET'
  });

export const updateIbanChangeRequest = ibanCode =>
  request(`${API_PUBLIC_BANK}/changeIBAN`, {
    method: 'PUT',
    params: {
      ibanCode
    }
  });

export const deleteIbanChangeRequest = () =>
  request(`${API_PUBLIC_BANK}/changeIBAN`, {
    method: 'DELETE'
  });

// IPRF Data

export const getIRPFData = () =>
  request(API_IRPF_DATA, {
    method: 'GET'
  });

export const getIRPFDataFromChangeRequest = () =>
  request(`${API_IRPF_DATA}/change`, {
    method: 'GET'
  });

export const deleteIRPFStatusChangeRequest = () =>
  request(`${API_IRPF_DATA}/change/irpfstatus`, {
    method: 'DELETE'
  });

export const deleteIRPFFamilyStatusChangeRequest = familyNumber =>
  request(`${API_IRPF_DATA}/change/irpffamstatus`, {
    method: 'DELETE',
    params: { familyNumber }
  });

export const createIRPFStatusChangeRequest = irpfData =>
  request(`${API_IRPF_DATA}/change/irpfstatus`, {
    method: 'POST',
    data: irpfData
  });

export const editIRPFStatusChangeRequest = irpfData =>
  request(`${API_IRPF_DATA}/change/irpfstatus`, {
    method: 'PUT',
    data: irpfData
  });

export const createFamStatusChangeRequest = famStatus =>
  request(`${API_IRPF_DATA}/change/irpffamstatus`, {
    method: 'POST',
    data: famStatus
  });

export const editFamStatusChangeRequest = famStatus =>
  request(`${API_IRPF_DATA}/change/irpffamstatus`, {
    method: 'PUT',
    data: famStatus
  });
